(function(d) {
    const btnContactMe = d.querySelector('input[id*="btnContact"]');
    if (btnContactMe) {
        btnContactMe.onclick = btnContactMeOnClick;
    }

    function btnContactMeOnClick() {
        var txbFullName = d.querySelector('input[id*="txbFullName"]');
        if (txbFullName) {
            setTimeout(function () { txbFullName.focus(); }, 1);
        }
    }
})(document);